import { render, staticRenderFns } from "./IconLogoStampCircle.vue?vue&type=template&id=4c057f26&scoped=true&"
import script from "./IconLogoStampCircle.vue?vue&type=script&lang=js&"
export * from "./IconLogoStampCircle.vue?vue&type=script&lang=js&"
import style0 from "./IconLogoStampCircle.vue?vue&type=style&index=0&id=4c057f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c057f26",
  null
  
)

export default component.exports